import { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "./AuthContext";

const AuthGuard = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      const query=new URLSearchParams(location.search);
      const key=['hostingClaim','hostingAdminClaim'].find(k=>/^[a-f0-9]{24}$/i.test(query.get(k)||''));
      if(location.pathname==='/dashboard'&&key)localStorage.setItem('postLoginRedirectPath','/dashboard?'+key+'='+encodeURIComponent(query.get(key)));
      navigate("/login");
    }
  }, [isAuthenticated, navigate, location.pathname, location.search]);

  return isAuthenticated ? children : null;
};

export default AuthGuard;